import React, { useState, useEffect } from "react";
import { appointments as appointmentsDuck, customers } from "../../ducks";
import duckify, { singleDuck } from "../../utils/duckify";
import { formatDateTime } from '../../utils'
import { zonedTimeToUtc } from "date-fns-tz";

const MultipleAppointments = ({ allDucksReady, appointments, cancelAppointment, customer, newAppointment }) => {
  const [confirmDeleteId, setConfirmDeleteId] = useState(null)
  const [localAppointments, setLocalAppointments] = useState([]);
  const parentName = `${appointments[0].first_name} ${appointments[0].last_name}`;
  const parentPhone = appointments[0].phone
  const parentEmail = appointments[0].email

  const groupedAppointments = localAppointments.reduce((acc, appointment) => {
    const { schedule_name } = appointment;
    if (!acc[schedule_name]) {
      acc[schedule_name] = [];
    }
    acc[schedule_name].push(appointment);
    return acc;
  }, {});

  useEffect(() => {
    setLocalAppointments(appointments);
  }, [appointments]);

  const onCancel = (appointmentId) => {
    cancelAppointment(appointmentId, setLocalAppointments)
  };

  return (
    <div className="form-import-paragraph hint">
      <div className="parent-contact-info">
        <h3>Parent Contact</h3>
        <p><span className="contact-description">Name:</span> {parentName}</p>
        <p><span className="contact-description">Phone:</span> {parentPhone}</p>
        <p><span className="contact-description">Email:</span> {parentEmail}</p>
      </div>

      <div className="appointment-container">
        <div className="multiple-appointments">
          <div className="row title-row ">
            <h2>Upcoming Appointments</h2>
          </div>
          {
            Object.entries(groupedAppointments).map(([scheduleName, appointments]) => (
              <div key={scheduleName} className="schedule-group">
                <h3>{scheduleName}</h3>
                {appointments.map((appointment) => (
                  <div key={appointment.id} className="appointment-item">
                    <p>
                      {`${formatDateTime(zonedTimeToUtc(appointment.start_date, customer.time_zone), 'fns_date')} ${appointment.start_time} - ${appointment.end_time}`}
                      <span className="cancel-button">
                        {
                          confirmDeleteId === appointment.id ?
                            <span className="confirmation-prompt">
                              <span className="confirmation-text">Are you sure?</span>
                              <button className="btn btn-success" onClick={() => onCancel(appointment.id)}>Yes</button>
                              <button className="btn btn-danger-inline" onClick={() => setConfirmDeleteId(null)}>No</button>
                            </span> :
                            <button className="btn btn-danger-inline" onClick={() => setConfirmDeleteId(appointment.id)}>
                              Cancel
                            </button>
                        }
                      </span>
                    </p>
                  </div>
                ))}
              </div>
            ))
          }
        </div>
        {allDucksReady && Object.keys(newAppointment).length > 0 ?
          <div className="new-appointment">
            <div className="row title-row">
              <h2>New Appointment</h2>
            </div>
            <div className="schedule-group">
              <h3>{newAppointment.schedule_name}</h3>
              <div className="appointment-item">
                <p>{`${formatDateTime(zonedTimeToUtc(newAppointment.start_date, customer.time_zone), 'fns_date')} ${newAppointment.start_time} - ${newAppointment.end_time}`}</p>
              </div>
            </div>
          </div> : ''
        }
      </div>
    </div>
  )
}

const mapDucksToProps = ({ appointmentId }) => ({
  customer: singleDuck(customers, 'current'),
  newAppointment: singleDuck(appointmentsDuck, appointmentId)
})

const mapDispatchToProps = (dispatch) => ({
  cancelAppointment: (appointmentId, setLocalAppointments) => {
    dispatch(appointmentsDuck.actions.remove({ id: appointmentId }))
      .then(() => dispatch(appointmentsDuck.actions.markDirty()))
      .then(() => dispatch(appointmentsDuck.actions.load()))
      .then(() => {
        setLocalAppointments((prevAppointments) =>
          prevAppointments.filter((appointment) => appointment.id !== appointmentId)
        );
      })
  }
})

export default duckify(mapDucksToProps, () => ({}), mapDispatchToProps)(MultipleAppointments)
